import React from 'react';
import { DI } from 'modules';
import Component from 'components/component';
import Form from 'common/components/form/new-form';
import Dropdown from 'components/dropdown';
import Validator from 'components/validator';

const scope = ['publish_pages', 'manage_pages', 'publish_video'].join(',');

export class TargetFacebookForm extends Component {
    state = {
        form: {
            key: '',
        },
        destanation: 'profile',
        profile: {},
        groups: [],
        accounts: [],
        events: [],
        targetID: null,
        pending: false,
    };

    destanations = [
        {
            title: this.props.common.strings[
                'page.lives.view.add_stream.fb.destanation.profile'
            ],
            value: 'profile',
        },
        {
            title: this.props.common.strings[
                'page.lives.view.add_stream.fb.destanation.groups'
            ],
            value: 'groups',
        },
        {
            title: this.props.common.strings[
                'page.lives.view.add_stream.fb.destanation.accounts'
            ],
            value: 'accounts',
        },
        {
            title: this.props.common.strings[
                'page.lives.view.add_stream.fb.destanation.events'
            ],
            value: 'events',
        },
    ];

    componentDidMount() {
        window.FB.login(
            (response) => {
                if (response.authResponse) {
                    window.FB.api('/me', (resp) =>
                        this.setState({
                            profile: resp,
                            targetID: resp.id,
                        })
                    );
                    window.FB.api('/me/groups', (resp) =>
                        this.setState({
                            groups: resp.data,
                        })
                    );
                    window.FB.api('/me/accounts', (resp) =>
                        this.setState({
                            accounts: resp.data,
                        })
                    );
                    window.FB.api('/me/events', (resp) =>
                        this.setState({
                            events: resp.data,
                        })
                    );
                } else {
                    console.log(
                        'User cancelled login or did not fully authorize.'
                    );
                }
            },
            { scope }
        );
    }

    onChange = (ev, form) => {
        this.setState({
            form,
            fbError: null,
        });
    };

    onSubmit = (ev, form) => {
        if (
            !this.state.pending &&
            this.onValidateForm.panic() &&
            this.state.targetID
        ) {
            this.setState({
                pending: true,
            });

            const params = {
                title: form.title,
                description: form.description,
                status: 'LIVE_NOW',
                privacy: {
                    value: 'SELF',
                },
            };

            if (this.state.destanation !== 'profile') {
                const page = this.state[this.state.destanation].find((page) => {
                    return page.id === this.state.targetID;
                });

                params.access_token = page.access_token;
            }

            window.FB.api(
                '/' + this.state.targetID + '/live_videos',
                'POST',
                params,
                (video_response) => {
                    if (!video_response.error) {
                        const { stream_url, id } = video_response;
                        let [primary_url, key] = stream_url.split(id);
                        key = id + key;

                        this.props.actions.targets
                            .createTarget(this.props.liveEvent.slug, {
                                language_id: this.props.selectedLanguageID,
                                primary_url,
                                key,
                                target_type: 'facebook',
                            })
                            .then((resp) => {
                                this.props.close();
                                return resp;
                            });
                    } else {
                        this.setState({
                            fbError: video_response.error.message,
                            pending: false,
                        });
                    }
                }
            );
        }
    };

    selectDestanation = (ev, destanation) => {
        if (destanation === 'profile') {
            this.setState({
                destanation,
                targetID: this.state.profile.id,
            });
        } else {
            this.setState({
                destanation,
                targetID: null,
            });
        }
    };

    selectTargetID = (ev, targetID) => {
        this.setState({
            targetID,
        });
    };

    onValidateForm = () => {};

    render() {
        const form = this.state.form;
        const strings = this.props.common.strings;

        const destanations = this.destanations.filter((item) => {
            if (this.state[item.value] instanceof Array) {
                return Boolean(this.state[item.value].length);
            }
            return true;
        });

        return (
            <Form onChange={this.onChange} onSubmit={this.onSubmit}>
                <div className="popup-stream">
                    <span className="popup__title">
                        {strings['page.lives.view.add_stream.title']}
                    </span>
                    <div className="stream">
                        <span
                            className={`stream__title stream__title--${this.props.id}`}
                        >
                            {this.props.targetName}
                        </span>
                        <div className="stream-form">
                            <Field
                                label={
                                    strings[
                                        'page.lives.view.add_stream.fb.title'
                                    ]
                                }
                                input={
                                    <Validator
                                        value={form.title}
                                        onValidateForm={this.onValidateForm}
                                        validators={['isRequired']}
                                        render={({
                                            hasError,
                                            messages,
                                            value,
                                        }) => (
                                            <input
                                                type="text"
                                                className={this.classList(
                                                    'input',
                                                    hasError && '_error'
                                                )}
                                                name="title"
                                                value={value}
                                                onChange={() => {}}
                                            />
                                        )}
                                    />
                                }
                            />
                            <Field
                                label={
                                    strings[
                                        'page.lives.view.add_stream.fb.description'
                                    ]
                                }
                                input={
                                    <Validator
                                        value={form.description}
                                        onValidateForm={this.onValidateForm}
                                        validators={['isRequired']}
                                        render={({
                                            hasError,
                                            messages,
                                            value,
                                        }) => (
                                            <input
                                                type="text"
                                                className={this.classList(
                                                    'input',
                                                    hasError && '_error'
                                                )}
                                                name="description"
                                                value={value}
                                                onChange={() => {}}
                                            />
                                        )}
                                    />
                                }
                            />
                            <Field
                                label={
                                    strings[
                                        'page.lives.view.add_stream.fb.destanation'
                                    ]
                                }
                                input={
                                    <Dropdown
                                        headerModificator={['big']}
                                        items={destanations}
                                        onChange={this.selectDestanation}
                                        value={this.state.destanation}
                                    />
                                }
                            />
                            {this.state[this.state.destanation] instanceof
                                Array && (
                                <Field
                                    input={
                                        <Dropdown
                                            headerModificator={['big']}
                                            items={
                                                this.state[
                                                    this.state.destanation
                                                ]
                                            }
                                            onChange={this.selectTargetID}
                                            value={this.state.targetID}
                                            getTitle={(item) => item.name}
                                            getValue={(item) => item.id}
                                        />
                                    }
                                />
                            )}
                            {this.state.fbError && (
                                <Field
                                    input={
                                        <span className="error">
                                            {this.state.fbError}
                                        </span>
                                    }
                                />
                            )}
                        </div>
                    </div>
                    <div className="popup-buttons popup-buttons--border">
                        <div className="popup-button">
                            <button
                                type="button"
                                className="text-button"
                                onClick={this.props.close}
                            >
                                {strings['page.lives.view.add_stream.cancel']}
                            </button>
                        </div>
                        <div className="popup-button">
                            <button
                                type="submit"
                                className="button"
                                disabled={this.state.pending}
                            >
                                {strings['page.lives.view.add_stream.submit']}
                            </button>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

function Field(props) {
    return (
        <div className="field">
            <div className="field-label">
                <label className="label">{props.label}</label>
            </div>
            <div className="field-input">{props.input}</div>
        </div>
    );
}

export default DI(['targets'])(TargetFacebookForm);
